import { memo, useState } from 'react'
import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { useGroupChatMemberList } from './useGroupChatMemberList'
import { GroupChatMemberListToolbar } from './components/groupChatMemberListToolbar/groupChatMemberListToolbar'
import { GroupChatMemberListGrid } from './components/groupChatMemberListGrid/groupChatMemberListGrid'

export const GroupChatMemberList = memo(() => {
  const { groupChatMemberListContext } = useGroupChatMemberList()
  const [selectedUserIds, setSelectedUserIds] = useState<string[]>([])

  return (
    <groupChatMemberListContext.Provider
      value={{
        selectedUserIds,
        setSelectedUserIds,
      }}
    >
      <div className="flex flex-col h-full w-full overflow-hidden">
        <CrewErrorBoundary>
          {/* メンバー一覧ツールバー */}
          <GroupChatMemberListToolbar />
        </CrewErrorBoundary>

        <CrewErrorBoundary>
          <div className="px-2 overflow-hidden flex-1">
            {/* メンバー一覧 */}
            <GroupChatMemberListGrid />
          </div>
        </CrewErrorBoundary>
      </div>
    </groupChatMemberListContext.Provider>
  )
})
